module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_06-dd34979485db9e1f824891941aa06519.jpg";